import { PropsWithChildren } from 'react';

import { SnackbarProvider as NotistackSnackbarProvider } from 'notistack';

export default function SnackbarProvider({ children }: PropsWithChildren) {
  return <NotistackSnackbarProvider maxSnack={3}>{children}</NotistackSnackbarProvider>;
}
